import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCode, FiLayout, FiMapPin, FiSmartphone, FiMousePointer, FiCpu } = FiIcons;

const Services = () => {
  const services = [
    {
      icon: FiCode,
      title: "Website Development",
      description: "Website profesional, cepat, responsif, dan dirancang untuk konversi, bukan sekadar terlihat bagus."
    },
    {
      icon: FiLayout,
      title: "Landing Page & Sales Page",
      description: "Halaman khusus untuk campaign, iklan, dan penawaran yang fokus closing."
    },
    {
      icon: FiMapPin,
      title: "Google Business Profile",
      description: "Optimasi Google Maps agar bisnis Anda lebih mudah ditemukan calon pelanggan di sekitar lokasi Anda."
    },
    {
      icon: FiSmartphone,
      title: "Social Media Management",
      description: "Konten strategis yang membangun kepercayaan dan mendukung funnel penjualan."
    },
    {
      icon: FiMousePointer,
      title: "Lead Generation",
      description: "Strategi mendatangkan leads berkualitas melalui digital marketing, bukan traffic kosong."
    },
    {
      icon: FiCpu,
      title: "Workflow Automation",
      description: "Otomatisasi proses bisnis agar Anda hemat waktu, tenaga, dan biaya operasional."
    }
  ];

  return (
    <section id="services" className="py-24 relative bg-[#0A192F]/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-5xl font-black text-white mb-6">
            Layanan <span className="text-orange-400">GedheMedia</span>
          </h2>
          <p className="text-xl text-gray-200 font-medium bg-white/5 py-3 px-6 rounded-full inline-block border border-white/10">
            Kami Membangun Sistem, Bukan Sekadar Tampilan
          </p>
          <p className="mt-8 text-gray-300 text-lg leading-relaxed">
            GedheMedia membantu bisnis lokal dengan pendekatan strategic & system-based, sehingga setiap channel digital saling terhubung untuk mendatangkan leads.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="service-card p-10 rounded-[2.5rem] group border border-white/10 bg-white/5 backdrop-blur-xl transition-all hover:bg-white/10" >
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-700 rounded-2xl flex items-center justify-center mb-8 shadow-lg group-hover:rotate-6 transition-transform">
                <SafeIcon icon={service.icon} className="text-white text-3xl" />
              </div>
              <h3 className="text-2xl font-black text-white mb-4">
                {service.title}
              </h3>
              <p className="text-gray-400 leading-relaxed font-semibold">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;